import lsAuth from '@/localstorage/auth.localstorage.js';

class AuthUtil {

    static setAuthToken(token) {

    	return lsAuth.set('token', token);
    }

    static setAuthMasterToken(token) {

    	return lsAuth.set('master_token', token);
    }

    static setAuth0Token(token) {

    	return lsAuth.set('auth0_token', token);
    }

    static getAuthToken() {

        return lsAuth.get('token');
    }

    static getMaterAuthToken() {

        return lsAuth.get('master_token');
    }

    static getAuth0Token() {

        return lsAuth.get('auth0_token');
    }

    static removeAuthToken() {
        return lsAuth.remove('token');
        return lsAuth.remove('master_token');
    }

    static removeAuth0Token() {
        return lsAuth.remove('auth0_token');
    }
}

export default AuthUtil;


// WEBPACK FOOTER //
// ./src/utils/auth.util.js